import { DateTime } from "luxon";
export class Formatter {
    // 1 = jan
    static month(index) {
        const monthNames = ["januari", "februari", "maart", "april", "mei", "juni",
            "juli", "augustus", "september", "oktober", "november", "december"
        ];
        return monthNames[index - 1];
    }
    static weekDay(date, timezone = "Europe/Brussels") {
        const dateTime = DateTime.fromJSDate(date).setZone(timezone);
        const monthNames = ["maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag", "zondag"];
        return monthNames[dateTime.weekday - 1];
    }
    /**
     * 1 januari (2020)
     */
    static date(date, timezone = "Europe/Brussels") {
        const dateTime = DateTime.fromJSDate(date).setZone(timezone);
        return dateTime.day + " " + this.month(dateTime.month) + " " + dateTime.year;
    }
    /**
     * maandag, 1 januari (2020)
     */
    static dateWithDay(date, timezone = "Europe/Brussels") {
        return this.weekDay(date, timezone) + ", " + this.date(date, timezone);
    }
    /**
     * maandag, 1 januari (2020)
     */
    static dateTimeWithDay(date, timezone = "Europe/Brussels") {
        return this.weekDay(date, timezone) + ", " + this.dateTime(date, timezone);
    }
    /**
    * 01/01/2020
    */
    static dateNumber(date, timezone = "Europe/Brussels") {
        const dateTime = DateTime.fromJSDate(date).setZone(timezone);
        const year = dateTime.year;
        return (dateTime.day + "").padStart(2, "0") + "/" + ((dateTime.month) + "").padStart(2, "0") + "/" + year;
    }
    /**
     * 2020-01-31
     */
    static dateIso(date, timezone = "Europe/Brussels") {
        const dateTime = DateTime.fromJSDate(date).setZone(timezone);
        const year = dateTime.year;
        return year + "-" + ((dateTime.month) + "").padStart(2, "0") + "-" + (dateTime.day + "").padStart(2, "0");
    }
    /**
     * 12:00
     */
    static time(date, timezone = "Europe/Brussels") {
        const dateTime = DateTime.fromJSDate(date).setZone(timezone);
        return dateTime.hour + ":" + (dateTime.minute + "").padStart(2, "0");
    }
    static uniqueArray(array) {
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
        return array.filter(onlyUnique);
    }
    /**
     * 1 januari (2020) om 12:00. Year only in different year
     */
    static dateTime(date, timezone = "Europe/Brussels") {
        return this.date(date, timezone) + " om " + this.time(date, timezone);
    }
    static price(value) {
        const formatted = new Intl.NumberFormat("nl-BE", {
            style: "currency",
            currency: "EUR",
        }).format(Math.abs(value) / 100);
        if (value < 0) {
            return "- " + formatted.replace(new RegExp("EUR", "ig"), '€');
        }
        return formatted.replace(new RegExp("EUR", "ig"), '€');
    }
    static capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}
//# sourceMappingURL=Formatter.js.map